
// Copyright Notice - All Rights Reserved
// This code is proprietary and confidential
// Unauthorized copying, distribution, or modification is strictly prohibited

interface ProtectionConfig {
  enableAntiDebug: boolean;
  enableConsoleWarnings: boolean;
  enableDevToolsDetection: boolean;
}

class CodeProtection {
  private config: ProtectionConfig;
  private isProduction: boolean;
  private isDevelopment: boolean;
  private isLovableEditor: boolean;

  constructor(config: ProtectionConfig) {
    this.config = config;
    this.isProduction = process.env.NODE_ENV === 'production';
    this.isDevelopment = process.env.NODE_ENV === 'development';
    
    // Detect if we're in Lovable editor environment
    this.isLovableEditor = typeof window !== 'undefined' && (
      window.location.hostname.includes('lovable.app') ||
      window.location.hostname.includes('localhost') ||
      window.location.hostname.includes('127.0.0.1') ||
      window.parent !== window || // iframe detection
      !!document.querySelector('[data-lovable]') // Lovable specific elements
    );
  }

  init() {
    // Only activate minimal protection in production
    if (!this.isProduction || this.isDevelopment || this.isLovableEditor) {
      console.log('🔧 Development mode - Protection disabled');
      return;
    }

    // Only add copyright notice in production, no intrusive measures
    this.addCopyrightNotice();
    
    // Disable the more aggressive protections that interfere with normal browsing
    // if (this.config.enableAntiDebug) {
    //   this.enableAntiDebug();
    // }

    // if (this.config.enableConsoleWarnings) {
    //   this.addConsoleWarnings();
    // }

    // if (this.config.enableDevToolsDetection) {
    //   this.detectDevTools();
    // }
  }

  private enableAntiDebug() {
    // Disabled - too intrusive for normal users
    return;
  }

  private addConsoleWarnings() {
    // Disabled - interferes with normal console usage
    return;
  }

  private detectDevTools() {
    // Disabled - can cause performance issues
    return;
  }

  private handleDebugDetection() {
    // Disabled
    return;
  }

  private handleDevToolsOpen() {
    // Disabled
    return;
  }

  private addCopyrightNotice() {
    // Simple, non-intrusive copyright notice
    if (this.isDevelopment || this.isLovableEditor) {
      console.log('© ' + new Date().getFullYear() + ' VakantieUitzoeken.com - Development Mode');
      return;
    }
    
    // Minimal copyright notice that doesn't interfere with user experience
    console.log(`© ${new Date().getFullYear()} VakantieUitzoeken.com - Alle rechten voorbehouden`);
  }

  // Obfuscate critical functions - simplified version
  public obfuscateFunction(fn: Function): Function {
    // Always return original function to avoid breaking functionality
    return fn;
  }
}

// Initialize protection with much lighter configuration
const protection = new CodeProtection({
  enableAntiDebug: false,        // Disabled to prevent interference
  enableConsoleWarnings: false,  // Disabled to allow normal console usage
  enableDevToolsDetection: false // Disabled to prevent performance issues
});

// Auto-initialize on import, but with minimal impact
if (typeof window !== 'undefined') {
  protection.init();
}

export { CodeProtection, protection };
